import Konva from "konva";

export class KonvaImageEditor
{
    private container: HTMLElement;
    private width: number;
    private height: number;
    private konvaStage: Konva.Stage;
    private layer: Konva.Layer;
    private video: HTMLVideoElement;
    private webcamImage: Konva.Image;
    private overlayedImage: HTMLImageElement;
    private tr1: Konva.Transformer;
    private anim: Konva.Animation;

    private stream: any;
    constructor(container: HTMLElement, overlayedImageSrc: string)
    {
        this.container = container;
        this.width = window.innerWidth;
        this.height = window.innerHeight;

        this.konvaStage = new Konva.Stage({
            container: this.container.id,
            width: this.width,
            height: this.height,
        });

        this.layer = new Konva.Layer();
        this.konvaStage.add(this.layer);

        this.video = document.createElement('video');
        this.video.width = this.width;
        this.video.height = this.height;
        this.video.playsInline = true;

        console.log(this.width, this.height);

        this.webcamImage = new Konva.Image({
            image: this.video,
            draggable: false,
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
        });
        this.layer.add(this.webcamImage);

        this.overlayedImage = new Image();
        this.overlayedImage.onload = () =>
        {
            const image = new Konva.Image({
                image: this.overlayedImage,
                draggable: true,
                width: this.overlayedImage.width * 0.5,
                height: this.overlayedImage.height * 0.5,
                x: 50,
                y: 20,
            });

            this.layer.add(image);

            this.tr1 = new Konva.Transformer({
                nodes: [image],
                keepRatio: true,
                enabledAnchors: [
                    'top-left',
                    'top-right',
                    'bottom-left',
                    'bottom-right',
                ],
                boundBoxFunc: function (oldBoundBox, newBoundBox)
                {
                    // "boundBox" is an object with
                    // x, y, width, height and rotation properties
                    // transformer tool will try to fit nodes into that box

                    // the logic is simple, if new width is too big
                    // we will return previous state
                    if (Math.abs(newBoundBox.width) > 250)
                    {
                        return oldBoundBox;
                    }

                    if (Math.abs(newBoundBox.width) < 50)
                    {
                        return oldBoundBox;
                    }

                    return newBoundBox;
                },
            });

            this.layer.add(this.tr1);
        };

        this.overlayedImage.src = overlayedImageSrc;

        this.anim = new Konva.Animation(() =>
        {

            // do nothing, animation just need to update the layer
        }, this.layer);
    }

    public async start(): Promise<void>
    {
        try
        {
            if (this.stream != null)
            {
                this.stop();
            }
            this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
            this.video.srcObject = this.stream;
            this.video.onloadedmetadata = (e) => this.onVideoLoaded();
        }
        catch (err)
        {
            console.log('Error accessing webcam:', err);
        }
    }

    private onVideoLoaded(): void 
    {
        const videoAspectRatio = this.video.videoWidth / this.video.videoHeight;
        const containerHeight = this.container.offsetHeight;
        const videoWidth = containerHeight * videoAspectRatio;

        this.webcamImage.width(videoWidth);
        // this.webcamImage.height(containerHeight); // Possibly squishing the iphone pro feed

        this.video.style.display = "none";

        this.play();
    }

    public play(): void 
    {
        this.tr1.show();
        this.video.play();
        this.anim.start();
    }

    public pause(): void 
    {
        this.tr1.hide();
        this.video.pause();
        this.anim.stop();
    }

    public stop(): void 
    {
        if (this.stream)
        {
            this.stream.getTracks().forEach((track) =>
            {
                if (track.readyState === "live")
                {
                    track.stop();
                }
            });
        }
    }

    public savePhotoToDisk(): void 
    {
        this.tr1.hide();
        let url = this.konvaStage.toDataURL({
            pixelRatio: 2,
            mimeType: "image/jpeg"
        });
        let link = document.createElement('a');
        link.href = url;
        link.download = "scene.jpg";
        link.click();
    }

    public getImage(): string 
    {
        this.tr1.hide();
        let url = this.konvaStage.toDataURL({
            pixelRatio: 2,
            // width: 720,
        });
        return url;
    }
}
